// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
import LocalTime from "local-time"

ActiveStorage.start()
LocalTime.start()

// Action Text / Trix
import "trix"
import "@rails/actiontext"
